import Component from "../../Component";
import BookingApi from "./BookingApi";
import EmployeeApi from "./EmployeeApi";
import SeatApi from "./SeatApi";
import FloorplanApi from "./FloorplanApi";
import LocationApi from "./LocationApi";
import RoomApi from "./RoomApi";
import DepartmentApi from "./DepartmentApi";

/**
 * Global API Service - Central hub for all API operations
 * Uses composition to provide access to all domain-specific APIs
 */
export default class ApiService {
    private readonly component: Component;

    public readonly booking: BookingApi;
    public readonly employee: EmployeeApi;
    public readonly seat: SeatApi;
    public readonly floorplan: FloorplanApi;
    public readonly location: LocationApi;
    public readonly room: RoomApi;
    public readonly department: DepartmentApi;

    constructor(component: Component) {
        this.component = component;

        this.booking = new BookingApi(component);
        this.employee = new EmployeeApi(component);
        this.seat = new SeatApi(component);
        this.floorplan = new FloorplanApi(component);
        this.location = new LocationApi(component);
        this.room = new RoomApi(component);
        this.department = new DepartmentApi(component);
    }
}
